import { CheveronDownIcon } from '../../../components/Icons/CheveronDownIcon';
import CrmIcon from '../../../components/Icons/CrmIcon';
import { HomeIcon } from '../../../components/Icons/HomeIcon';
import { PickListIcon } from '../../../components/Icons/PickListIcon';
import { UserIcon } from '../../../components/Icons/UserIcon';
import WarehouseIcon from '../../../components/Icons/WarehouseIcon';
import {
  CRM,
  HOME,
  PICKLIST,
  USER,
  WAREHOUSE,
} from '../../../routes/routeConstants';

export const navConfig = [
  {
    title: 'Home',
    path: HOME,
    icon: <HomeIcon />,
  },
  {
    title: 'Pick List',
    path: PICKLIST,
    icon: <PickListIcon />,
  },

  {
    title: 'Warehouse',
    path: WAREHOUSE,
    icon: <WarehouseIcon />,
  },

  {
    title: 'User',
    path: USER,
    icon: <UserIcon />,
    rightIcon: <CheveronDownIcon />,
  },

  {
    title: 'CRM',
    path: CRM,
    icon: <CrmIcon />,
  },
];
